import { VendorSearch, VendorSearchResult, DeleteVendorResponse } from "@/types/Vendor";
import { adminBaseQueryWrapper } from "@/utils/rtkHelper";
import { createApi } from "@reduxjs/toolkit/query/react";

export const vendorApi = createApi({
  reducerPath: "vendorApi",
  baseQuery: adminBaseQueryWrapper,
  tagTypes: ["vendor"],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getVendorById: builder.query<any, any>({
      query: ({ id }) => `/vendors/${id}`,
      providesTags: ["vendor"],
    }),

    getVendors: builder.query({
      query: () => `/vendors`,
      providesTags: ["vendor"],
    }),

    searchVendors: builder.query<VendorSearchResult, VendorSearch>({
      query: (input) => ({
        url: `/vendors/search`,
        method: "POST",
        body: input,
      }),
      providesTags: ["vendor"],
    }),

    createVendor: builder.mutation<void, any>({
      query: (input) => ({
        url: `/vendors`,
        method: "POST",
        body: input,
      }),
      invalidatesTags: ["vendor"],
    }),
    updateVendor: builder.mutation<void, { id: number; data: any }>({
      query: ({ id, data }) => ({
        url: `/vendors/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["vendor"],
    }),
    updateVendorAddress: builder.mutation<void, { id: number; data: any }>({
      query: ({ id, data }) => ({
        url: `/vendors/address/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["vendor"],
    }),
    updateVendorOtherDetail: builder.mutation<void, { id: number; data: any }>({
      query: ({ id, data }) => ({
        url: `/vendors/other-detail/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["vendor"],
    }),
    deleteVendor: builder.mutation<DeleteVendorResponse, { id: number }>({
      query: ({ id }) => ({
        url: `/vendors/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["vendor"],
    }),
  })
})

export const {
  useGetVendorByIdQuery,
  useCreateVendorMutation,
  useUpdateVendorMutation,
  useSearchVendorsQuery,
  useUpdateVendorAddressMutation,
  useUpdateVendorOtherDetailMutation,
  useGetVendorsQuery,
  useDeleteVendorMutation
} = vendorApi;
